import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_BASE || 'https://power.gailtechnology.com/api';

export async function fetchForecastLines(targetDate) {
  const res = await axios.get(`${API_BASE}/forecast_lines/${targetDate}`);
  return res.data; // Return the whole object, not res.data.lines
}

// Fetch forecast lines for multiple dates in parallel, returns an object {date: response}
export async function fetchForecastLinesMulti(dates) {
  const results = await Promise.all(
    dates.map(date =>
      axios.get(`${API_BASE}/forecast_lines/${date}`)
        .then(res => ({ date, data: res.data }))
        .catch(() => ({ date, data: null }))
    )
  );
  const out = {};
  results.forEach(({ date, data }) => { out[date] = data; });
  return out;
}

export async function fetchTemperatures(targetDate) {
  const res = await axios.get(`${API_BASE}/temperatures/${targetDate}`);
  return res.data;
}

export async function fetchAvailableDates() {
  const res = await axios.get(`${API_BASE}/available_dates`); // API_BASE is now relative by default
  return res.data.dates;
}

// Fetch the 5-day forecast window (future mode) as published in a given sheet
export async function fetchForecastWindow(sheetDate) {
  const res = await axios.get(`${API_BASE}/forecast_window/${sheetDate}`);
  return res.data;
}
